import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: "Home", path: "/" },
    { name: "Events", path: "/events" },
    { name: "Quiz Sets", path: "/quiz-sets" },
    { name: "Articles", path: "/articles" },
    { name: "Gallery", path: "/gallery" },
    { name: "Team", path: "/team" },
    { name: "Contact", path: "/contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50">
      {/* Black accent frosted background */}
      <div className="bg-black/20 backdrop-blur-3xl shadow-lg border-b border-black/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2">
              <img
                src="/logo-192x192.png"
                alt="Quizzers Anonymous Logo"
                className="w-8 h-8 rounded-full object-cover"
              />
              <span
                className="font-bold text-xl text-white drop-shadow-md"
                style={{ fontFamily: "'Honk', cursive" }}
              >
                Quizzers Anonymous
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-all duration-300 ${
                    isActive(item.path)
                      ? "text-white bg-black/40 backdrop-blur-md shadow-md border border-black/50"
                      : "text-white/80 hover:text-white hover:bg-black/30 hover:backdrop-blur-md hover:shadow-md hover:border hover:border-black/40"
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden flex items-center">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-white/80 hover:text-accent-blue focus:outline-none focus:text-accent-blue"
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {isOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  )}
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isOpen && (
            <div className="md:hidden mt-2">
              <div className="bg-black/20 backdrop-blur-3xl rounded-xl px-3 py-4 space-y-1 shadow-lg border border-black/30">
                {navItems.map((item) => (
                  <Link
                    key={item.name}
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className={`block px-3 py-2 rounded-md text-base font-medium transition-all duration-300 ${
                      isActive(item.path)
                        ? "text-white bg-black/40 backdrop-blur-md shadow-md border border-black/50"
                        : "text-white/80 hover:text-white hover:bg-black/30 hover:backdrop-blur-md hover:shadow-md hover:border hover:border-black/40"
                    }`}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
